import Axes from '../../sceneWrapper/types/Axes';

/** The position of the pointer in the time of the last mousedown or touchstart event. */
const pointerdownPos: Pick<Axes, 'x' | 'y'> = {
    x: 0,
    y: 0
};

export default pointerdownPos;
